import {
    AuthenticationActionsTypes
} from "@Actions-Types";

import {
    AuthenticationActions
} from "@Actions";

import {
    QyvoUserModel
} from "@Models/Users";


interface AuthenticationReducerStateInterface {
    QyvoUser: QyvoUserModel | null;
}

const StoredQyvoUser = localStorage.getItem('qyvo-web-app-logged-user');


const AuthenticationReducerState: AuthenticationReducerStateInterface = {
    QyvoUser: StoredQyvoUser ? JSON.parse(StoredQyvoUser) : null
};


export const AuthenticationReducer = (
    state = AuthenticationReducerState,
    action: AuthenticationActions
) => {

    switch (action.type) {

        case AuthenticationActionsTypes.USER_SIGN_IN:
            localStorage.setItem('qyvo-web-app-logged-user', JSON.stringify(action.QyvoUser))
            return { ...state, QyvoUser: action.QyvoUser};

        case AuthenticationActionsTypes.USER_SIGN_OUT:
            localStorage.removeItem('qyvo-web-app-logged-user');
            return { ...state, QyvoUser: null };

        default:
            return state;

    }

};


export default AuthenticationReducer;
